import { useState } from "react";

const EPICS = {
  AUTO:     { label: "Automatización",      color: "#4f46e5" },
  PACKS:    { label: "Packs",               color: "#0891b2" },
  WEB:      { label: "Web",                 color: "#059669" },
  GEO:      { label: "GEO/SEO",             color: "#65a30d" },
  SM:       { label: "Social Media",        color: "#db2777" },
  CONTENIDO:{ label: "Contenido Sesiones",  color: "#d97706" },
  B2B:      { label: "Comercial/B2B",       color: "#7c3aed" },
  ADMIN:    { label: "Admin/Fiscal",        color: "#64748b" },
  FUNNEL:   { label: "Funnel/Captación",    color: "#e11d48" },
  CAPTACION:{ label: "Captación orgánica",  color: "#0ea5e9" },
};

const COLS = [
  { id: "done",      label: "✅ Done" },
  { id: "sprint",    label: "🔥 Jun — Sistema + Cimientos" },
  { id: "captacion", label: "☀️ Jul-Ago — Lanzamiento + Construcción" },
  { id: "paralelo",  label: "🚀 Sept — Aceleración" },
  { id: "deferred",  label: "⏸ Oct+ / Descartado" },
];

const TASKS = [

  // ══════════════════════════════════════════════════════════════════════════
  // ✅ DONE
  // ══════════════════════════════════════════════════════════════════════════
  { id: 1,  title: "#1 · Alta como autónoma (RETA + Hacienda 037)", epic: "ADMIN", col: "done", h: 3 },
  { id: 2,  title: "#2 · Dominio polarishub.es + IONOS VPS", epic: "WEB", col: "done", h: 2 },
  { id: 3,  title: "#3 · WordPress + Astra + Elementor instalados", epic: "WEB", col: "done", h: 3 },
  { id: 4,  title: "#4 · Cal.com self-hosted operativo", epic: "AUTO", col: "done", h: 6 },
  { id: 5,  title: "#5 · HubSpot Free configurado (propiedades custom)", epic: "AUTO", col: "done", h: 4 },
  { id: 6,  title: "#6 · n8n self-hosted operativo", epic: "AUTO", col: "done", h: 4 },
  { id: 7,  title: "#7 · Stripe conectado a Cal.com (acct_1SpnAa8nSNFQXj86)", epic: "AUTO", col: "done", h: 3 },
  { id: 8,  title: "#8 · 6 tipos de sesión en Cal.com con pago (individuales)", epic: "AUTO", col: "done", h: 3 },
  { id: 9,  title: "#9 · Tally form pre-sesión (ID 2EOeWg) operativo", epic: "AUTO", col: "done", h: 2 },
  { id: 10, title: "#10 · Workflow 2: Tally → HubSpot + Google Drive CV ✅ testeado prod", epic: "AUTO", col: "done", h: 8 },
  { id: 11, title: "#11 · IONOS SMTP configurado en n8n", epic: "AUTO", col: "done", h: 1 },
  { id: 12, title: "#12 · Landing /cv-sin-experiencia/ publicada (GEO-first)", epic: "WEB", col: "done", h: 6 },
  { id: 13, title: "#13 · 7 sesiones piloto completadas (PMF validada — 4 testimonios recogibles)", epic: "ADMIN", col: "done", h: 14 },
  { id: 14, title: "#14 · Chatbot polarishub.es (chat-polarishub.html + n8n webhook)", epic: "WEB", col: "done", h: 5 },
  { id: 15, title: "#15 · Whereby configurado para videollamadas", epic: "AUTO", col: "done", h: 1 },
  { id: 16, title: "#16 · Ficha sesión CDA v3 (ref: Marta_Turias)", epic: "CONTENIDO", col: "done", h: 4 },
  { id: 17, title: "#17 · Email post-sesión plantilla fija", epic: "CONTENIDO", col: "done", h: 2 },
  { id: 18, title: "#18 · Cal.com event types sin pago para packs", epic: "PACKS", col: "done", h: 1 },
  { id: 19, title: "#19 · Tally → HubSpot conexión fija (error 405 resuelto)", epic: "AUTO", col: "done", h: 3 },
  { id: 28, title: "#28 · Webhook duplicado 'n8n-individual' Stripe eliminado", epic: "AUTO", col: "done", h: 0.5 },
  { id: 60, title: "#60 · Compatibilidad paro + autónoma — TRAMITADA", epic: "ADMIN", col: "done", h: 2 },
  { id: 61, title: "#61 · Ayuda Junta Andalucía Línea 2 Medida A — SOLICITADA (res. 30/06)", epic: "ADMIN", col: "done", h: 5 },
  { id: 62, title: "#62 · Workflow 1 (Stripe → HubSpot + Email E1) — construido y debuggeado", epic: "AUTO", col: "done", h: 12 },
  { id: 80, title: "#80 · Promesa 'Trabaja de lo Tuyo' en una frase verificable — CERRADO", epic: "CONTENIDO", col: "done", h: 1 },
  { id: 81, title: "#81 · Cliente ideal definido desde los 7 pilotos — CERRADO", epic: "CONTENIDO", col: "done", h: 2 },
  { id: 88, title: "#88 · Naming definitivo: 'Trabaja de lo Tuyo' — CERRADO", epic: "CONTENIDO", col: "done", h: 0.5 },

  // ══════════════════════════════════════════════════════════════════════════
  // 🔥 SPRINT JUNIO — Sistema listo + Cimientos lanzamiento
  // ══════════════════════════════════════════════════════════════════════════

  // ── Sistema existente: cerrar y testar ────────────────────────────────────
  { id: 20,    title: "#20 · Workflow 1: test final producción (Stripe → HubSpot + Email E1) — DONE", epic: "AUTO", col: "done", h: 1 },
  { id: 21,    title: "#21 · Workflow 3: recordatorio 15h antes sesiones individuales [PADRE]", epic: "AUTO", col: "sprint", dep: 20, h: 4, parent: true },
  { id: "21a", title: "#21a · Diseñar lógica condicional: formulario sí/no", epic: "AUTO", col: "sprint", h: 1, sub: 21 },
  { id: "21b", title: "#21b · Construir rama SÍ (recordatorio simple + enlace sesión)", epic: "AUTO", col: "sprint", h: 1, sub: 21 },
  { id: "21c", title: "#21c · Construir rama NO (recordatorio + link Tally + mención CV)", epic: "AUTO", col: "sprint", h: 1, sub: 21 },
  { id: "21d", title: "#21d · Test en producción ambas ramas", epic: "AUTO", col: "sprint", h: 1, sub: 21 },
  { id: 22,    title: "#22 · Actualizar home polarishub.es con CTA llamada 10min y servicios actuales", epic: "WEB", col: "sprint", dep: 20, h: 2 },
  { id: 23,    title: "#23 · n8n: recordatorio a Laura 1h post-sesión (para email post-sesión)", epic: "AUTO", col: "sprint", dep: 21, h: 2 },
  { id: 76,    title: "#76 · Prefijo teléfono +34 por defecto en Cal.com (30 min)", epic: "AUTO", col: "sprint", h: 0.5 },
  { id: 78,    title: "#78 · Gestión fiscal: aclarar declaración cuenta Stripe conectada vs principal", epic: "ADMIN", col: "sprint", h: 2 },
  { id: 29,    title: "#29 · Actualizar Documento_Maestro.docx tras cierre sistema", epic: "ADMIN", col: "sprint", dep: 23, h: 2 },

  // ── Pack 3 (único residual — pack 5 eliminado) ────────────────────────────
  { id: 40,    title: "#40 · Pack 3: Stripe Payment Link 130€ (pack 5 ELIMINADO)", epic: "PACKS", col: "sprint", h: 1 },
  { id: 41,    title: "#41 · Pack 3: workflow n8n activación [PADRE]", epic: "AUTO", col: "sprint", dep: 40, h: 3, parent: true },
  { id: "41a", title: "#41a · Workflow Stripe → HubSpot + email confirmación pack 3", epic: "AUTO", col: "sprint", h: 2, sub: 41 },
  { id: "41b", title: "#41b · Test workflow pack 3 en producción", epic: "AUTO", col: "sprint", h: 1, sub: 41 },
  { id: 42,    title: "#42 · Pack 3: identificación cliente por email al reservar sesiones", epic: "PACKS", col: "sprint", dep: 41, h: 2 },
  { id: 43,    title: "#43 · Pack 3: sección en polarishub.es [PADRE]", epic: "WEB", col: "sprint", dep: 40, h: 3, parent: true },
  { id: "43a", title: "#43a · Redactar copy pack 3 (residual, sin protagonismo)", epic: "WEB", col: "sprint", h: 1, sub: 43 },
  { id: "43b", title: "#43b · Maquetar en Elementor y conectar al Payment Link", epic: "WEB", col: "sprint", h: 2, sub: 43 },

  // ── Textos legales (bloqueante para cobrar) ───────────────────────────────
  { id: 70,    title: "#70 · Textos legales: privacidad + T&Cs en WordPress [PADRE] ⚠️ BLOQUEANTE", epic: "WEB", col: "sprint", h: 4, parent: true },
  { id: "70a", title: "#70a · Publicar Política de Privacidad (RGPD) — ya redactada", epic: "WEB", col: "sprint", h: 1, sub: 70 },
  { id: "70b", title: "#70b · Publicar Términos y Condiciones del servicio — ya redactados", epic: "WEB", col: "sprint", h: 1, sub: 70 },
  { id: "70c", title: "#70c · Enlazar desde footer + formularios + Cal.com", epic: "WEB", col: "sprint", h: 1, sub: 70 },
  { id: "70d", title: "#70d · Añadir checkbox RGPD en Cal.com (pendiente de T&C publicados)", epic: "WEB", col: "sprint", h: 1, sub: 70 },

  // ── Facturación ───────────────────────────────────────────────────────────
  { id: 53,    title: "#53 · Facturación Welocalize: automatización serie WLC [PADRE]", epic: "ADMIN", col: "sprint", h: 4, parent: true },
  { id: "53a", title: "#53a · Diseñar plantilla factura WLC en Excel", epic: "ADMIN", col: "sprint", h: 1, sub: 53 },
  { id: "53b", title: "#53b · Configurar numeración automática y datos fijos", epic: "ADMIN", col: "sprint", h: 1, sub: 53 },
  { id: "53c", title: "#53c · Exportar a PDF y protocolo de envío", epic: "ADMIN", col: "sprint", h: 1, sub: 53 },
  { id: "53d", title: "#53d · Registrar en LauraMolina_Gestion_2026_v3.xlsx", epic: "ADMIN", col: "sprint", h: 1, sub: 53 },
  { id: 54,    title: "#54 · Gastos: hoja de control mensual [PADRE]", epic: "ADMIN", col: "sprint", h: 3, parent: true },
  { id: "54a", title: "#54a · Crear hoja de gastos en LauraMolina_Gestion_2026_v3.xlsx", epic: "ADMIN", col: "sprint", h: 1, sub: 54 },
  { id: "54b", title: "#54b · Categorizar gastos deducibles (hosting, tools, telefonía, otros)", epic: "ADMIN", col: "sprint", h: 1, sub: 54 },
  { id: "54c", title: "#54c · Protocolo mensual: registro + revisión trimestral", epic: "ADMIN", col: "sprint", h: 1, sub: 54 },

  // ── NUEVO: Producto — pasos que venían del backlog de esta mañana ──────────
  { id: 82,    title: "#82 · Estructura RUMBO 6 semanas validada + sesión 1 diseñada al completo [PADRE]", epic: "CONTENIDO", col: "sprint", h: 4, parent: true },
  { id: "82a", title: "#82a · Confirmar orden sesiones 1-6 (CDA: Claridad→Dirección→Acción)", epic: "CONTENIDO", col: "sprint", h: 1, sub: 82 },
  { id: "82b", title: "#82b · Diseñar sesión 1 completa: guion + ficha CDA + material entre-sesión", epic: "CONTENIDO", col: "sprint", h: 3, sub: 82 },
  { id: 83,    title: "#83 · Plantilla de vídeo reutilizable para batches (estructura fija, solo cambia contenido) [PADRE]", epic: "SM", col: "sprint", h: 3, parent: true },
  { id: "83a", title: "#83a · Definir estructura fija: intro (5s) + gancho + desarrollo + CTA + outro (2s)", epic: "SM", col: "sprint", h: 1, sub: 83 },
  { id: "83b", title: "#83b · Montar plantilla base en CapCut con marcadores de tiempo y transiciones fijas", epic: "SM", col: "sprint", h: 1, sub: 83 },
  { id: "83c", title: "#83c · Grabar primer vídeo con la plantilla y validar que el sistema funciona", epic: "SM", col: "sprint", h: 1, sub: 83 },
  { id: 84,    title: "#84 · TikTok: configurar cuenta y protocolo de reaprovechamiento desde Instagram", epic: "SM", col: "sprint", h: 2 },
  { id: 85,    title: "#85 · Captura de email en /cv-sin-experiencia/: formulario + secuencia mínima [PADRE]", epic: "FUNNEL", col: "sprint", h: 4, parent: true },
  { id: "85a", title: "#85a · Añadir formulario de captura (nombre + email) al final de la página GEO existente", epic: "FUNNEL", col: "sprint", h: 1, sub: 85 },
  { id: "85b", title: "#85b · Conectar formulario a lista en Brevo/MailerLite gratuito", epic: "FUNNEL", col: "sprint", h: 1, sub: 85 },
  { id: "85c", title: "#85c · Redactar 2 emails de bienvenida automáticos (no nurturing largo — solo valor inmediato)", epic: "FUNNEL", col: "sprint", h: 2, sub: 85 },
  { id: 86,    title: "#86 · Audiencia prestada: mapa de canales y primeros contactos (podcasts + colaboraciones) [PADRE]", epic: "CAPTACION", col: "sprint", h: 3, parent: true },
  { id: "86a", title: "#86a · Identificar 10 podcasts objetivo y escuchar episodio de c/u", epic: "CAPTACION", col: "sprint", h: 2, sub: 86 },
  { id: "86b", title: "#86b · Redactar plantilla de propuesta personalizable (no genérica)", epic: "CAPTACION", col: "sprint", h: 1, sub: 86 },
  { id: 87,    title: "#87 · Plan de Social Media completo — SIGUIENTE PASO [PADRE]", epic: "SM", col: "sprint", h: 6, parent: true },
  { id: "87a", title: "#87a · Pilares de contenido definidos (dolor 40% / mitos 30% / utilidad 10% / proceso 20%)", epic: "SM", col: "sprint", h: 1, sub: 87 },
  { id: "87b", title: "#87b · Calendario julio en Buffer/Sheets (12 posts listos antes del 30 jun)", epic: "SM", col: "sprint", h: 2, sub: 87 },
  { id: "87c", title: "#87c · Batch julio grabado y editado con plantilla #83 (al menos 6 vídeos)", epic: "SM", col: "sprint", h: 3, sub: 87 },

  // ── NUEVO: Trabaja de lo Tuyo — stack mínimo para vender ─────────────────
  { id: 89,     title: "#89 · Cal.com: crear evento 'Llamada gratuita 10 min' ⚠️ BLOQUEANTE (enlace de bio de todo el contenido)", epic: "AUTO", col: "sprint", h: 0.5 },
  { id: 110,    title: "#110 · Trabaja de lo Tuyo: Stripe Payment Link 450€ ⚠️ BLOQUEANTE", epic: "AUTO", col: "sprint", h: 1 },
  { id: 111,    title: "#111 · Trabaja de lo Tuyo: event type Cal.com sin cobro para sesiones RUMBO ⚠️ BLOQUEANTE", epic: "AUTO", col: "sprint", dep: 110, h: 1 },
  { id: 112,    title: "#112 · Trabaja de lo Tuyo: página /trabaja-de-lo-tuyo/ en WordPress [PADRE] ⚠️ BLOQUEANTE", epic: "WEB", col: "sprint", dep: 110, h: 4, parent: true },
  { id: "112a", title: "#112a · Redactar promesa A→B en una frase verificable", epic: "WEB", col: "sprint", h: 1, sub: 112 },
  { id: "112b", title: "#112b · Maquetar página mínima: promesa + qué incluye + mapa 6 semanas + botón pago", epic: "WEB", col: "sprint", h: 2, sub: 112 },
  { id: "112c", title: "#112c · Conectar botón a Stripe Payment Link #110", epic: "WEB", col: "sprint", h: 1, sub: 112 },
  { id: 113,    title: "#113 · Trabaja de lo Tuyo: workflow n8n completo (13 pasos) [PADRE] ⚠️ BLOQUEANTE", epic: "AUTO", col: "sprint", dep: 111, h: 16, parent: true },
  { id: "113a", title: "#113a · Paso 1-2: Stripe webhook → HubSpot (tipo_servicio=RUMBO, sesiones_restantes=6)", epic: "AUTO", col: "sprint", h: 2, sub: 113 },
  { id: "113b", title: "#113b · Paso 3: generación factura PDF automática → cliente + Laura + Sheets", epic: "AUTO", col: "sprint", h: 2, sub: 113 },
  { id: "113c", title: "#113c · Paso 4: email E-BIENVENIDA automático (mapa 6sem + Cal.com + WhatsApp + promesa)", epic: "AUTO", col: "sprint", h: 2, sub: 113 },
  { id: "113d", title: "#113d · Paso 6-7: cliente reserva sesión en Cal.com → Tally pre-sesión → HubSpot", epic: "AUTO", col: "sprint", h: 2, sub: 113 },
  { id: "113e", title: "#113e · Paso 8: recordatorio condicional 15h antes (mismo lógica que #21 pero para RUMBO)", epic: "AUTO", col: "sprint", h: 2, sub: 113 },
  { id: "113f", title: "#113f · Paso 10: email post-sesión con plantilla base (Laura personaliza en 10min)", epic: "AUTO", col: "sprint", h: 2, sub: 113 },
  { id: "113g", title: "#113g · Paso 13: email seguimiento automático 30 días post-cierre", epic: "AUTO", col: "sprint", h: 2, sub: 113 },
  { id: "113h", title: "#113h · Test flujo completo de punta a punta en producción", epic: "AUTO", col: "sprint", h: 2, sub: 113 },
  { id: 114,    title: "#114 · Trabaja de lo Tuyo: diseño sesiones 2-6 just-in-time (ver #82 para sesión 1) — arrancar tras primer cliente", epic: "CONTENIDO", col: "sprint", h: 1 },
  { id: 102,    title: "#102 · WhatsApp Business: configurar canal abierto para acompañamiento RUMBO", epic: "AUTO", col: "sprint", h: 2 },

  // ── NUEVO: Cimientos captación (junio) ────────────────────────────────────
  { id: 117,    title: "#117 · Testimonios piloto: recoger, formatear y publicar mínimo 3 [PADRE]", epic: "CAPTACION", col: "sprint", h: 3, parent: true },
  { id: "117a", title: "#117a · Escribir a los 4 del piloto (mensaje exacto en Plan Lanzamiento)", epic: "CAPTACION", col: "sprint", h: 0.5, sub: 117 },
  { id: "117b", title: "#117b · Formatear respuestas: texto 3-5 líneas + nombre + situación", epic: "CAPTACION", col: "sprint", h: 1, sub: 117 },
  { id: "117c", title: "#117c · Publicar en home web + preparar assets Instagram", epic: "CAPTACION", col: "sprint", h: 1.5, sub: 117 },
  // (batch vídeos cubierto por #83 plantilla + #87 plan SM)

  // ══════════════════════════════════════════════════════════════════════════
  // ☀️ JUL-AGO — Lanzamiento real + Construcción
  // ══════════════════════════════════════════════════════════════════════════

  // ── Optimización perfil Instagram (sprint — hacer esta semana) ─────────────
  { id: 124,    title: "#124 · Optimización perfil Instagram — consenso 3 análisis [PADRE]", epic: "SM", col: "sprint", h: 4, parent: true },
  { id: "124a", title: "#124a · Nombre de perfil → 'Laura Molina | Empleo para Graduados' (2 min)", epic: "SM", col: "sprint", h: 0.5, sub: 124 },
  { id: "124b", title: "#124b · Bio: dolor + promesa + CV·LI·Entrevistas + CTA llamada 10min (5 min)", epic: "SM", col: "sprint", h: 0.5, sub: 124 },
  { id: "124c", title: "#124c · Enlace en bio → evento Cal.com llamada gratuita 10min (único enlace, único destino)", epic: "SM", col: "sprint", h: 0.5, sub: 124 },
  { id: "124d", title: "#124d · 5 highlights: EMPIEZA AQUÍ · CASOS REALES · CV Y LINKEDIN · ENTREVISTAS · RESERVA", epic: "SM", col: "sprint", h: 1, sub: 124 },
  { id: "124e", title: "#124e · 3 posts fijados: (1) Quién soy vídeo · (2) Caso real anonimizado · (3) Cómo funciona el proceso", epic: "SM", col: "sprint", h: 1.5, sub: 124 },
  { id: "124f", title: "#124f · Unificar feed: navy/gold/cream Nunito, título máx 6 palabras, fondo claro — igual que web", epic: "SM", col: "sprint", h: 0.5, sub: 124 },

  // ── Guiones: posts fijados + primeros 5 reels ────────────────────────────
  { id: 125,    title: "#125 · Guiones posts fijados + 5 primeros reels [PADRE]", epic: "SM", col: "sprint", h: 3, parent: true },
  { id: "125a", title: "#125a · Pin 1 — Quién soy (60-90s: historia + por qué hago esto)", epic: "SM", col: "sprint", h: 0.5, sub: 125 },
  { id: "125b", title: "#125b · Pin 2 — Caso real anonimizado (situación → error → cambio → resultado)", epic: "SM", col: "sprint", h: 0.5, sub: 125 },
  { id: "125c", title: "#125c · Pin 3 — Cómo funciona el proceso (4-5 pasos desde llamada hasta trabajo)", epic: "SM", col: "sprint", h: 0.5, sub: 125 },
  { id: "125d", title: "#125d · Reel 1: 'Llevo 10 seg viendo tu CV y ya sé por qué no te llaman'", epic: "SM", col: "sprint", h: 0.5, sub: 125 },
  { id: "125e", title: "#125e · Reel 2: 'Si llevas meses enviando CVs sin respuesta, escucha esto'", epic: "SM", col: "sprint", h: 0.5, sub: 125 },
  { id: "125f", title: "#125f · Reels 3-5: El error del 80% · Enviaste 100 CVs · Tres señales de que aplicas a puestos equivocados", epic: "SM", col: "sprint", h: 0.5, sub: 125 },

  // ── Instagram (motor principal) ───────────────────────────────────────────
  { id: 30,    title: "#30 · Instagram: publicaciones regulares 3/semana [PADRE]", epic: "SM", col: "captacion", h: 12, parent: true },
  { id: "30a", title: "#30a · Perfil optimizado (ver #124) — prerequisito antes de publicar en batch", epic: "SM", col: "captacion", dep: 124, h: 0, sub: 30 },
  { id: "30b", title: "#30b · Programar batch 1 julio en Buffer (semanas 1-2)", epic: "SM", col: "captacion", h: 1, sub: 30 },
  { id: "30c", title: "#30c · Grabar y editar batch 2 julio (semanas 3-4)", epic: "SM", col: "captacion", h: 4, sub: 30 },
  { id: "30d", title: "#30d · Programar batch 2 en Buffer", epic: "SM", col: "captacion", h: 1, sub: 30 },
  { id: "30e", title: "#30e · Grabar y editar batch septiembre (12 posts) — antes 25 agosto", epic: "SM", col: "captacion", h: 5, sub: 30 },

  // ── Optimización perfil LinkedIn (sprint — misma semana que #124) ──────────
  { id: 126,    title: "#126 · Optimización perfil LinkedIn — consenso 3 análisis [PADRE]", epic: "SM", col: "sprint", h: 3, parent: true },
  { id: "126a", title: "#126a · Nombre: incluir keyword buscable → 'Laura Molina | Orientación Laboral para Jóvenes'", epic: "SM", col: "sprint", h: 0.5, sub: 126 },
  { id: "126b", title: "#126b · About (extracto): dolor + promesa + método CDA en 3 párrafos + CTA llamada 10min", epic: "SM", col: "sprint", h: 0.5, sub: 126 },
  { id: "126c", title: "#126c · Banner: diseño coherente con web (navy/gold/cream, promesa en una línea)", epic: "SM", col: "sprint", h: 0.5, sub: 126 },
  { id: "126d", title: "#126d · Featured: anclar los 3 posts estratégicos (quién soy + caso real + proceso)", epic: "SM", col: "sprint", h: 0.5, sub: 126 },
  { id: "126e", title: "#126e · Activar modo creador + enlace destacado → Cal.com llamada 10min", epic: "SM", col: "sprint", h: 0.5, sub: 126 },
  { id: "126f", title: "#126f · Keywords en titular, about y experiencia (orientación laboral, empleo jóvenes, graduados)", epic: "SM", col: "sprint", h: 0.5, sub: 126 },

  // ── LinkedIn ──────────────────────────────────────────────────────────────
  { id: 31,    title: "#31 · LinkedIn: activar presencia 1-2 posts/semana [PADRE]", epic: "SM", col: "captacion", h: 8, parent: true },
  { id: "31a", title: "#31a · Actualizar perfil LinkedIn (banner, about, featured, modo creador activado)", epic: "SM", col: "captacion", h: 1, sub: 31 },
  { id: "31b", title: "#31b · Adaptar y publicar batch 1 (posts de IG a formato LI, julio)", epic: "SM", col: "captacion", h: 2, sub: 31 },
  { id: "31c", title: "#31c · Adaptar y publicar batch 2 (agosto)", epic: "SM", col: "captacion", h: 2, sub: 31 },
  { id: "31d", title: "#31d · Conectar 20-30 perfiles/semana de público objetivo (sept)", epic: "SM", col: "captacion", h: 3, sub: 31 },

  // ── Calendario editorial ──────────────────────────────────────────────────
  { id: 33,    title: "#33 · Calendario editorial Q3 2026 [PADRE]", epic: "SM", col: "captacion", h: 3, parent: true },
  { id: "33a", title: "#33a · Definir pilares de contenido y formatos (ya definidos en Plan Lanzamiento)", epic: "SM", col: "captacion", h: 0.5, sub: 33 },
  { id: "33b", title: "#33b · Crear calendario julio en Buffer/Sheets", epic: "SM", col: "captacion", h: 1, sub: 33 },
  { id: "33c", title: "#33c · Crear calendario agosto en Buffer/Sheets", epic: "SM", col: "captacion", h: 0.5, sub: 33 },
  { id: "33d", title: "#33d · Crear calendario septiembre en Buffer/Sheets", epic: "SM", col: "captacion", h: 1, sub: 33 },

  // ── Referidos (protocolo) ─────────────────────────────────────────────────
  { id: 34,    title: "#34 · Protocolo referidos: mensaje piloto + cierre de sesión [PADRE]", epic: "CAPTACION", col: "captacion", h: 2, parent: true },
  { id: "34a", title: "#34a · Enviar mensaje de seguimiento a los 7 del piloto (semana 1 julio)", epic: "CAPTACION", col: "captacion", h: 0.5, sub: 34 },
  { id: "34b", title: "#34b · Implementar pregunta de referido al final de cada sesión/llamada", epic: "CAPTACION", col: "captacion", h: 0.5, sub: 34 },
  { id: "34c", title: "#34c · Seguimiento 2ª ronda piloto en septiembre", epic: "CAPTACION", col: "captacion", h: 1, sub: 34 },

  // ── GEO páginas (antes SEO blog — completamente rediseñado) ───────────────
  { id: 35,    title: "#35 · GEO página-respuesta 1: '¿Qué hacer cuando acabas la carrera y no sabes qué hacer?' [PADRE]", epic: "GEO", col: "captacion", h: 5, parent: true },
  { id: "35a", title: "#35a · Identificar pregunta-consulta principal tal como se formula a ChatGPT/Perplexity", epic: "GEO", col: "captacion", h: 1, sub: 35 },
  { id: "35b", title: "#35b · Redactar: respuesta directa 60-80 palabras + 800-1.200 denso + FAQ + CDA + CTA llamada 10min", epic: "GEO", col: "captacion", h: 2, sub: 35 },
  { id: "35c", title: "#35c · Maquetar en Elementor y publicar en polarishub.es", epic: "GEO", col: "captacion", h: 2, sub: 35 },
  { id: 118,    title: "#118 · GEO página-respuesta 2: 'Llevo meses enviando CVs sin respuesta' [PADRE]", epic: "GEO", col: "captacion", h: 5, parent: true },
  { id: "118a", title: "#118a · Investigar variantes de la consulta en IAs + keywords vecinas validadas", epic: "GEO", col: "captacion", h: 1, sub: 118 },
  { id: "118b", title: "#118b · Redactar estructura GEO-first completa", epic: "GEO", col: "captacion", h: 2, sub: 118 },
  { id: "118c", title: "#118c · Maquetar y publicar", epic: "GEO", col: "captacion", h: 2, sub: 118 },
  { id: 32,    title: "#32 · Google Business Profile: crear y optimizar ficha (Sevilla + online)", epic: "GEO", col: "captacion", h: 2 },
  { id: 72,    title: "#72 · Valorar alojar formularios Tally en polarishub.es (tráfico adicional)", epic: "GEO", col: "captacion", h: 1 },

  // ── Trabaja de lo Tuyo: diseño sesiones 2-6 (just-in-time) ───────────────
  { id: 115,    title: "#115 · Trabaja de lo Tuyo: diseño sesiones 2-6 just-in-time [PADRE]", epic: "CONTENIDO", col: "captacion", h: 20, parent: true },
  { id: "115a", title: "#115a · Diseñar sesión 2: Marca personal y posicionamiento (jul sem 2)", epic: "CONTENIDO", col: "captacion", h: 4, sub: 115 },
  { id: "115b", title: "#115b · Diseñar sesión 3: CV y portfolio (jul sem 3)", epic: "CONTENIDO", col: "captacion", h: 4, sub: 115 },
  { id: "115c", title: "#115c · Diseñar sesión 4: LinkedIn y búsqueda activa (jul sem 4)", epic: "CONTENIDO", col: "captacion", h: 4, sub: 115 },
  { id: "115d", title: "#115d · Diseñar sesión 5: Entrevistas (ago sem 1)", epic: "CONTENIDO", col: "captacion", h: 4, sub: 115 },
  { id: "115e", title: "#115e · Diseñar sesión 6: Cierre + ficha CDA final + plan 60 días (ago sem 2)", epic: "CONTENIDO", col: "captacion", h: 4, sub: 115 },

  // ── Audiencia prestada: podcasts ──────────────────────────────────────────
  { id: 119,    title: "#119 · Protocolo contacto podcasts: 5-8 propuestas enviadas [PADRE]", epic: "CAPTACION", col: "captacion", h: 6, parent: true },
  { id: "119a", title: "#119a · Identificar 10 podcasts objetivo (empleabilidad, orientación, vida universitaria, desarrollo profesional joven)", epic: "CAPTACION", col: "captacion", h: 2, sub: 119 },
  { id: "119b", title: "#119b · Escuchar 15-20 min de c/u y anotar ángulo propio personalizado", epic: "CAPTACION", col: "captacion", h: 2, sub: 119 },
  { id: "119c", title: "#119c · Enviar 5-8 propuestas personalizadas (julio-agosto)", epic: "CAPTACION", col: "captacion", h: 1, sub: 119 },
  { id: "119d", title: "#119d · Seguimiento único a no-respondedores (1 solo intento)", epic: "CAPTACION", col: "captacion", h: 1, sub: 119 },

  // ── Audiencia prestada: colaboraciones institucionales ────────────────────
  { id: 121,    title: "#121 · Protocolo charlas colaboradoras: másteres, FP, universidades online [PADRE]", epic: "B2B", col: "captacion", h: 5, parent: true },
  { id: "121a", title: "#121a · Identificar 15 programas objetivo (másteres con perfil en transición)", epic: "B2B", col: "captacion", h: 2, sub: 121 },
  { id: "121b", title: "#121b · Redactar propuesta de charla (45min gratuita + valor para el programa)", epic: "B2B", col: "captacion", h: 1, sub: 121 },
  { id: "121c", title: "#121c · Enviar 10 propuestas (agosto — para ejecutar charlas en sept-oct)", epic: "B2B", col: "captacion", h: 1, sub: 121 },
  { id: "121d", title: "#121d · Confirmar fechas y preparar materiales de charla", epic: "B2B", col: "captacion", h: 1, sub: 121 },

  // ══════════════════════════════════════════════════════════════════════════
  // 🚀 SEPT — Aceleración
  // ══════════════════════════════════════════════════════════════════════════

  { id: 71,    title: "#71 · Página confirmación post-booking Cal.com (redirect personalizado)", epic: "WEB", col: "paralelo", h: 1 },
  { id: 52,    title: "#52 · Workflow post-sesión individual: follow-up 48h [PADRE]", epic: "AUTO", col: "paralelo", h: 3, parent: true },
  { id: "52a", title: "#52a · Trigger: detectar sesión completada en Cal.com", epic: "AUTO", col: "paralelo", h: 1, sub: 52 },
  { id: "52b", title: "#52b · Actualizar estado HubSpot → seguimiento_pendiente", epic: "AUTO", col: "paralelo", h: 1, sub: 52 },
  { id: "52c", title: "#52c · Email automático follow-up 48h post-sesión individual", epic: "AUTO", col: "paralelo", h: 1, sub: 52 },
  { id: 79,    title: "#79 · Calendario lanzamiento Q4 2026 + Q1 2027 [PADRE]", epic: "FUNNEL", col: "paralelo", h: 3, parent: true },
  { id: "79a", title: "#79a · Definir comunicación subida precio 600€ (noviembre → enero)", epic: "FUNNEL", col: "paralelo", h: 1, sub: 79 },
  { id: "79b", title: "#79b · Planificar contenido previo a activación pagada (oct-nov)", epic: "FUNNEL", col: "paralelo", h: 1, sub: 79 },
  { id: "79c", title: "#79c · Abrir agenda enero antes del 15 diciembre", epic: "FUNNEL", col: "paralelo", h: 1, sub: 79 },
  { id: 120,    title: "#120 · Protocolo contacto psicólogos y coaches bienestar Sevilla [PADRE]", epic: "B2B", col: "paralelo", h: 3, parent: true },
  { id: "120a", title: "#120a · Identificar 15 profesionales (psicólogos, coaches) con audiencia similar", epic: "B2B", col: "paralelo", h: 1, sub: 120 },
  { id: "120b", title: "#120b · Redactar email de propuesta de derivación mutua", epic: "B2B", col: "paralelo", h: 1, sub: 120 },
  { id: "120c", title: "#120c · Enviar 10 emails personalizados (octubre)", epic: "B2B", col: "paralelo", h: 1, sub: 120 },

  // ══════════════════════════════════════════════════════════════════════════
  // ⏸ OCT+ / DIFERIDO / DESCARTADO
  // ══════════════════════════════════════════════════════════════════════════

  // ── Meta Ads (nov-ene, con 3 testimonios) ─────────────────────────────────
  { id: 77,    title: "#77 · Meta Ads: test campana Trabaja de lo Tuyo (nov-ene, con 3 testimonios) [PADRE]", epic: "SM", col: "deferred", h: 8, parent: true },
  { id: "77a", title: "#77a · Definir objetivo, público y presupuesto mínimo (300€/mes test)", epic: "SM", col: "deferred", h: 1, sub: 77 },
  { id: "77b", title: "#77b · Crear creatividades basadas en testimonios reales (3-5 variantes)", epic: "SM", col: "deferred", h: 3, sub: 77 },
  { id: "77c", title: "#77c · Configurar campaña y lanzar", epic: "SM", col: "deferred", h: 2, sub: 77 },
  { id: "77d", title: "#77d · Revisar métricas semana 1 y optimizar (CPL objetivo < 15€)", epic: "SM", col: "deferred", h: 2, sub: 77 },

  // ── Prensa ────────────────────────────────────────────────────────────────
  { id: 122,    title: "#122 · Prensa: nota de prensa a medios locales y especializados [PADRE]", epic: "CAPTACION", col: "deferred", h: 4, parent: true },
  { id: "122a", title: "#122a · Redactar nota de prensa (ángulo: orientadora + IA para jóvenes en transición)", epic: "CAPTACION", col: "deferred", h: 2, sub: 122 },
  { id: "122b", title: "#122b · Enviar a El Correo de Andalucía, Diario de Sevilla, InfoJobs blog, Universia", epic: "CAPTACION", col: "deferred", h: 1, sub: 122 },
  { id: "122c", title: "#122c · Seguimiento y gestión de respuestas", epic: "CAPTACION", col: "deferred", h: 1, sub: 122 },

  // ── GEO página 3 (después de indexar las dos primeras) ───────────────────
  { id: 123,    title: "#123 · GEO página-respuesta 3: 'Cómo ayudar a mi hijo/a recién graduado/a sin rumbo' [PADRE]", epic: "GEO", col: "deferred", h: 5, parent: true },
  { id: "123a", title: "#123a · Investigar consulta + keywords vecinas (segmento padres 40-55)", epic: "GEO", col: "deferred", h: 1, sub: 123 },
  { id: "123b", title: "#123b · Redactar estructura GEO-first completa", epic: "GEO", col: "deferred", h: 2, sub: 123 },
  { id: "123c", title: "#123c · Maquetar y publicar", epic: "GEO", col: "deferred", h: 2, sub: 123 },

  // ── Webinar (Q4, requiere audiencia previa) ───────────────────────────────
  { id: 101,    title: "#101 · Webinar: guion + slides — DIFERIDO Q4 (requiere audiencia 500+ seg.) [PADRE]", epic: "FUNNEL", col: "deferred", h: 8, parent: true },
  { id: "101a", title: "#101a · Estructura del webinar (apertura, valor, transición a venta, cierre)", epic: "FUNNEL", col: "deferred", h: 2, sub: 101 },
  { id: "101b", title: "#101b · Redactar guion completo (40-60 min)", epic: "FUNNEL", col: "deferred", h: 3, sub: 101 },
  { id: "101c", title: "#101c · Maquetar slides en Canva", epic: "FUNNEL", col: "deferred", h: 2, sub: 101 },
  { id: "101d", title: "#101d · Ensayo + ajuste de ritmo y timing", epic: "FUNNEL", col: "deferred", h: 1, sub: 101 },

  // ── Secuencia emails nurturing (Q4, depende de audiencia email) ───────────
  { id: 100,    title: "#100 · Secuencia emails nurturing — DIFERIDO Q4 [PADRE]", epic: "FUNNEL", col: "deferred", h: 6, parent: true },
  { id: "100a", title: "#100a · Redactar email 1: bienvenida + historia PolarisHub", epic: "FUNNEL", col: "deferred", h: 1, sub: 100 },
  { id: "100b", title: "#100b · Redactar email 2: dolor del público + metodología CDA", epic: "FUNNEL", col: "deferred", h: 1, sub: 100 },
  { id: "100c", title: "#100c · Redactar email 3: caso real anonimizado", epic: "FUNNEL", col: "deferred", h: 1, sub: 100 },
  { id: "100d", title: "#100d · Redactar email 4-6: invitación webinar + recordatorios", epic: "FUNNEL", col: "deferred", h: 2, sub: 100 },
  { id: "100e", title: "#100e · Configurar secuencia en Brevo/MailerLite gratuito + test", epic: "FUNNEL", col: "deferred", h: 1, sub: 100 },

  // ── Automatizaciones avanzadas (post-facturación) ─────────────────────────
  { id: 36,    title: "#36 · ManyChat Instagram DM automation — DIFERIDO post-sept [PADRE]", epic: "SM", col: "deferred", dep: 30, h: 4, parent: true },
  { id: "36a", title: "#36a · Configurar cuenta ManyChat y conectar Instagram", epic: "SM", col: "deferred", h: 1, sub: 36 },
  { id: "36b", title: "#36b · Construir flujo: keyword → respuesta automática + link llamada", epic: "SM", col: "deferred", h: 2, sub: 36 },
  { id: "36c", title: "#36c · Testear flujo y publicar", epic: "SM", col: "deferred", h: 1, sub: 36 },
  { id: 73,    title: "#73 · Chatbot web: actualizar integración (nuevas sesiones y precios) [PADRE]", epic: "WEB", col: "deferred", h: 3, parent: true },
  { id: "73a", title: "#73a · Revisar y actualizar prompts del agente n8n", epic: "WEB", col: "deferred", h: 1, sub: 73 },
  { id: "73b", title: "#73b · Actualizar UI del chat (Trabaja de lo Tuyo, precio 450€)", epic: "WEB", col: "deferred", h: 1, sub: 73 },
  { id: "73c", title: "#73c · Test de flujo completo y publicar", epic: "WEB", col: "deferred", h: 1, sub: 73 },
  { id: 74,    title: "#74 · Kit Digital Segmento III (octubre 2026) [PADRE]", epic: "ADMIN", col: "deferred", h: 5, parent: true },
  { id: "74a", title: "#74a · Verificar requisitos y elegibilidad cuando abra convocatoria", epic: "ADMIN", col: "deferred", h: 1, sub: 74 },
  { id: "74b", title: "#74b · Preparar documentación necesaria", epic: "ADMIN", col: "deferred", h: 2, sub: 74 },
  { id: "74c", title: "#74c · Presentar solicitud", epic: "ADMIN", col: "deferred", h: 2, sub: 74 },
  { id: 103,    title: "#103 · Agentes IA para clientes (CV, entrevistas, marca personal — ~20-30€/mes) [PADRE]", epic: "AUTO", col: "deferred", h: 30, parent: true },
  { id: "103a", title: "#103a · Definir alcance y casos de uso de cada agente", epic: "AUTO", col: "deferred", h: 2, sub: 103 },
  { id: "103b", title: "#103b · Construir agente IA: optimización de CV", epic: "AUTO", col: "deferred", h: 8, sub: 103 },
  { id: "103c", title: "#103c · Construir agente IA: preparación de entrevistas", epic: "AUTO", col: "deferred", h: 8, sub: 103 },
  { id: "103d", title: "#103d · Construir agente IA: marca personal y LinkedIn", epic: "AUTO", col: "deferred", h: 8, sub: 103 },
  { id: "103e", title: "#103e · Integrar agentes en web + sistema de pago suscripción mensual", epic: "AUTO", col: "deferred", h: 4, sub: 103 },

  // ── DESCARTADOS (visibles para referencia, marcados como tal) ─────────────
  { id: 75,    title: "#75 · ❌ DESCARTADO: Blog SEO tradicional → sustituido por GEO páginas #35 y #118", epic: "GEO", col: "deferred", h: 0 },
  { id: 97,    title: "#97 · ❌ DESCARTADO: Lead magnet PDF → no es la palanca correcta a este ticket", epic: "FUNNEL", col: "deferred", h: 0 },
  { id: 98,    title: "#98 · ❌ DESCARTADO: Funnel Polarizar → sustituido por workflow Trabaja de lo Tuyo (#113)", epic: "FUNNEL", col: "deferred", h: 0 },
  { id: 99,    title: "#99 · ❌ DESCARTADO: Contenido programa Polarizar (40h) → diseño just-in-time en #114 y #115", epic: "CONTENIDO", col: "deferred", h: 0 },
  { id: 50,    title: "#50 · ❌ DESCARTADO: Cold outreach másteres por email → sustituido por charlas colaboradoras #121", epic: "B2B", col: "deferred", h: 0 },
  { id: 51,    title: "#51 · ❌ DESCARTADO: Cold outreach academias por email → sustituido por charlas colaboradoras #121", epic: "B2B", col: "deferred", h: 0 },
];

const COL_STYLE = {
  done:      { bg: "#dcfce7", border: "#16a34a" },
  sprint:    { bg: "#fee2e2", border: "#dc2626" },
  captacion: { bg: "#fef3c7", border: "#d97706" },
  paralelo:  { bg: "#dbeafe", border: "#2563eb" },
  deferred:  { bg: "#f1f5f9", border: "#94a3b8" },
};

function DepBadge({ dep }) {
  if (!dep) return null;
  return (
    <span style={{ fontSize: 10, color: "#92400e", background: "#fef3c7", borderRadius: 4, padding: "1px 5px" }}>
      🔗 Necesita #{dep}
    </span>
  );
}

function HourBadge({ h }) {
  if (!h) return null;
  const color = h <= 2 ? "#16a34a" : h <= 8 ? "#d97706" : "#dc2626";
  const label = h < 1 ? "30 min" : h === 1 ? "1h" : `${h}h`;
  return (
    <span style={{ fontSize: 10, color: "#fff", background: color, borderRadius: 4, padding: "1px 6px", fontWeight: 600 }}>
      ⏱ {label}
    </span>
  );
}

function TaskModal({ task, state, onClose, onDone, onMove, onDelete, onSaveNote }) {
  const [note, setNote] = useState(state.notes[task.id] || "");
  const epic = EPICS[task.epic];
  const isDone = state.done.has(String(task.id));
  const currentCol = state.cols[task.id] || task.col;

  const btn = (label, onClick, color = "#0f1f3d") => (
    <button onClick={onClick} style={{
      background: color, color: "#fff", border: "none", borderRadius: 6,
      padding: "8px 14px", fontSize: 12, cursor: "pointer", fontFamily: "inherit", fontWeight: 600,
    }}>{label}</button>
  );

  return (
    <div style={{
      position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", zIndex: 1000,
      display: "flex", alignItems: "center", justifyContent: "center", padding: 16,
    }} onClick={onClose}>
      <div onClick={e => e.stopPropagation()} style={{
        background: "#fff", borderRadius: 12, padding: 20, width: "100%", maxWidth: 420,
        borderTop: `4px solid ${epic.color}`, boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
      }}>
        <div style={{ fontWeight: 700, fontSize: 13, color: "#1e293b", marginBottom: 4 }}>
          {task.title.replace(" [PADRE]", "")}
        </div>
        <div style={{ display: "flex", gap: 5, flexWrap: "wrap", marginBottom: 14 }}>
          <span style={{ fontSize: 10, color: "#fff", background: epic.color, borderRadius: 4, padding: "1px 6px" }}>{epic.label}</span>
          <HourBadge h={task.h} />
          <DepBadge dep={task.dep} />
        </div>
        <div style={{ marginBottom: 14 }}>
          <div style={{ fontSize: 11, fontWeight: 700, color: "#64748b", marginBottom: 4 }}>📝 NOTA</div>
          <textarea
            value={note}
            onChange={e => setNote(e.target.value)}
            placeholder="Añade una nota a esta tarea..."
            rows={3}
            style={{
              width: "100%", borderRadius: 6, border: "1px solid #e2e8f0",
              padding: "8px 10px", fontSize: 12, fontFamily: "inherit",
              resize: "vertical", boxSizing: "border-box", color: "#1e293b",
            }}
          />
          {btn("Guardar nota", () => { onSaveNote(task.id, note); onClose(); }, "#059669")}
        </div>
        <div style={{ marginBottom: 14 }}>
          <div style={{ fontSize: 11, fontWeight: 700, color: "#64748b", marginBottom: 6 }}>↕️ MOVER A</div>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
            {COLS.filter(c => c.id !== currentCol).map(c => (
              <button key={c.id} onClick={() => { onMove(task.id, c.id); onClose(); }} style={{
                fontSize: 11, padding: "4px 10px", borderRadius: 6,
                border: `1px solid ${COL_STYLE[c.id].border}`,
                background: COL_STYLE[c.id].bg, color: "#1e293b",
                cursor: "pointer", fontFamily: "inherit",
              }}>{c.label}</button>
            ))}
          </div>
        </div>
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
          {btn(
            isDone ? "↩ Desmarcar hecho" : "✅ Marcar como hecho",
            () => { onDone(task.id); onClose(); },
            isDone ? "#64748b" : "#16a34a"
          )}
          {btn("🗑 Eliminar", () => {
            if (window.confirm("¿Eliminar esta tarea?")) { onDelete(task.id); onClose(); }
          }, "#dc2626")}
          <button onClick={onClose} style={{
            background: "#f1f5f9", color: "#475569", border: "none", borderRadius: 6,
            padding: "8px 14px", fontSize: 12, cursor: "pointer", fontFamily: "inherit",
          }}>Cerrar</button>
        </div>
      </div>
    </div>
  );
}

function TaskCard({ task, state, onOpen }) {
  const epic = EPICS[task.epic];
  const isDone = state.done.has(String(task.id));
  const note = state.notes[task.id];
  const isDiscarded = task.title.startsWith("#") && task.title.includes("❌");

  return (
    <div
      onClick={() => onOpen(task)}
      style={{
        background: isDiscarded ? "#fef2f2" : isDone ? "#f0fdf4" : "#fff",
        border: "1px solid #e5e7eb",
        borderLeft: `3px solid ${isDiscarded ? "#dc2626" : isDone ? "#16a34a" : epic.color}`,
        borderRadius: 6, padding: "8px 10px", marginBottom: 6,
        fontSize: 12, lineHeight: 1.45, cursor: "pointer",
        opacity: isDone || isDiscarded ? 0.65 : 1,
      }}
    >
      <div style={{
        color: isDone || isDiscarded ? "#64748b" : "#1e293b",
        fontWeight: 500,
        textDecoration: isDone || isDiscarded ? "line-through" : "none",
      }}>
        {isDone ? "✅ " : ""}{task.title}
      </div>
      <div style={{ marginTop: 4, display: "flex", gap: 5, flexWrap: "wrap", alignItems: "center" }}>
        <span style={{ fontSize: 10, color: "#fff", background: epic.color, borderRadius: 4, padding: "1px 6px" }}>
          {epic.label}
        </span>
        <HourBadge h={task.h} />
        <DepBadge dep={task.dep} />
        {note && <span style={{ fontSize: 10, color: "#7c3aed" }}>📝</span>}
      </div>
      {note && (
        <div style={{ marginTop: 5, fontSize: 11, color: "#475569", fontStyle: "italic", borderTop: "1px solid #f1f5f9", paddingTop: 4 }}>
          {note.length > 80 ? note.slice(0, 80) + "…" : note}
        </div>
      )}
    </div>
  );
}

function ParentCard({ task, children, state, onOpen }) {
  const [open, setOpen] = useState(false);
  const epic = EPICS[task.epic];
  const isDone = state.done.has(String(task.id));
  const note = state.notes[task.id];
  const doneSubs = children.filter(c => state.done.has(String(c.id))).length;

  return (
    <div style={{ marginBottom: 6 }}>
      <div style={{
        background: isDone ? "#f0fdf4" : "#f0f4ff",
        border: `1px solid ${epic.color}`,
        borderLeft: `4px solid ${isDone ? "#16a34a" : epic.color}`,
        borderRadius: open ? "6px 6px 0 0" : 6,
        padding: "8px 10px", fontSize: 12, lineHeight: 1.45,
        opacity: isDone ? 0.7 : 1,
      }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 6 }}>
          <div
            onClick={() => setOpen(o => !o)}
            style={{ color: isDone ? "#64748b" : "#1e293b", fontWeight: 700, flex: 1, cursor: "pointer", userSelect: "none",
              textDecoration: isDone ? "line-through" : "none" }}
          >
            {open ? "▾" : "▸"} {isDone ? "✅ " : ""}{task.title.replace(" [PADRE]", "")}
          </div>
          <button onClick={() => onOpen(task)} style={{
            background: "none", border: "1px solid #cbd5e1", borderRadius: 4,
            fontSize: 10, padding: "2px 6px", cursor: "pointer", color: "#64748b", whiteSpace: "nowrap",
          }}>···</button>
        </div>
        <div style={{ marginTop: 4, display: "flex", gap: 5, flexWrap: "wrap", alignItems: "center" }}>
          <span style={{ fontSize: 10, color: "#fff", background: epic.color, borderRadius: 4, padding: "1px 6px" }}>{epic.label}</span>
          <HourBadge h={task.h} />
          <DepBadge dep={task.dep} />
          <span style={{ fontSize: 10, color: "#475569" }}>{doneSubs}/{children.length} subtareas</span>
          {note && <span style={{ fontSize: 10, color: "#7c3aed" }}>📝</span>}
        </div>
        {note && (
          <div style={{ marginTop: 5, fontSize: 11, color: "#475569", fontStyle: "italic", borderTop: "1px solid #e2e8f0", paddingTop: 4 }}>
            {note.length > 80 ? note.slice(0, 80) + "…" : note}
          </div>
        )}
      </div>
      {open && (
        <div style={{
          border: `1px solid ${epic.color}`, borderTop: "none",
          borderRadius: "0 0 6px 6px", background: "#fafbff",
          padding: "4px 4px 4px 10px",
        }}>
          {children.map(sub => (
            <TaskCard key={sub.id} task={sub} state={state} onOpen={onOpen} />
          ))}
        </div>
      )}
    </div>
  );
}

function ColContent({ tasks, state, onOpen }) {
  const subMap = {};
  tasks.filter(t => t.sub).forEach(s => {
    if (!subMap[s.sub]) subMap[s.sub] = [];
    subMap[s.sub].push(s);
  });
  const rendered = [];
  const seen = new Set();
  tasks.forEach(t => {
    if (seen.has(t.id) || t.sub) return;
    seen.add(t.id);
    if (t.parent) {
      rendered.push(<ParentCard key={t.id} task={t} children={subMap[t.id] || []} state={state} onOpen={onOpen} />);
    } else {
      rendered.push(<TaskCard key={t.id} task={t} state={state} onOpen={onOpen} />);
    }
  });
  return <>{rendered}</>;
}

export default function Backlog() {
  const [filterEpic, setFilterEpic] = useState("ALL");
  const [activeTask, setActiveTask] = useState(null);
  const [state, setState] = useState({
    cols: {}, done: new Set(), notes: {}, deleted: new Set(),
  });

  const handleDone    = (id) => setState(s => { const done = new Set(s.done); done.has(String(id)) ? done.delete(String(id)) : done.add(String(id)); return { ...s, done }; });
  const handleMove    = (id, colId) => setState(s => ({ ...s, cols: { ...s.cols, [id]: colId } }));
  const handleDelete  = (id) => setState(s => { const deleted = new Set(s.deleted); deleted.add(String(id)); return { ...s, deleted }; });
  const handleSaveNote= (id, note) => setState(s => ({ ...s, notes: { ...s.notes, [id]: note } }));

  const liveTasks = TASKS
    .filter(t => !state.deleted.has(String(t.id)))
    .map(t => ({ ...t, col: state.cols[t.id] || t.col }));

  const allVisible = filterEpic === "ALL"
    ? liveTasks
    : liveTasks.filter(t => {
        if (t.epic === filterEpic) return true;
        if (t.sub) { const p = liveTasks.find(p => p.id === t.sub); return p && p.epic === filterEpic; }
        return false;
      });

  const topLevel = allVisible.filter(t => !t.sub);
  const totalH   = topLevel.filter(t => t.h > 0).reduce((s, t) => s + (t.h || 0), 0);

  return (
    <div style={{ fontFamily: "'Nunito','Segoe UI',sans-serif", background: "#F7F3F3", minHeight: "100vh", padding: "20px 16px", boxSizing: "border-box" }}>

      {activeTask && (
        <TaskModal task={activeTask} state={state} onClose={() => setActiveTask(null)}
          onDone={handleDone} onMove={handleMove} onDelete={handleDelete} onSaveNote={handleSaveNote} />
      )}

      <div style={{ background: "#0f1f3d", borderRadius: 10, padding: "16px 20px", marginBottom: 16, display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 8 }}>
        <div>
          <div style={{ color: "#c9a84c", fontWeight: 800, fontSize: 20, letterSpacing: 1 }}>✦ POLARISHUB — BACKLOG</div>
          <div style={{ color: "#94a3b8", fontSize: 11, marginTop: 3 }}>Actualizado 15/06/2026 · v3 fusionada · Sincronizado con Plan de Lanzamiento · Toca cualquier tarea para editarla</div>
        </div>
        <div style={{ background: "#c9a84c", color: "#0f1f3d", fontWeight: 700, fontSize: 13, borderRadius: 20, padding: "4px 14px" }}>
          {topLevel.filter(t => t.h > 0).length} tareas activas · {totalH}h
        </div>
      </div>

      <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginBottom: 16 }}>
        <button onClick={() => setFilterEpic("ALL")} style={{ fontSize: 11, padding: "4px 12px", borderRadius: 20, border: "none", cursor: "pointer", fontFamily: "inherit", background: filterEpic === "ALL" ? "#0f1f3d" : "#e2e8f0", color: filterEpic === "ALL" ? "#fff" : "#475569", fontWeight: filterEpic === "ALL" ? 700 : 400 }}>Todas</button>
        {Object.entries(EPICS).map(([key, e]) => (
          <button key={key} onClick={() => setFilterEpic(filterEpic === key ? "ALL" : key)} style={{ fontSize: 11, padding: "4px 12px", borderRadius: 20, border: "none", cursor: "pointer", fontFamily: "inherit", background: filterEpic === key ? e.color : "#e2e8f0", color: filterEpic === key ? "#fff" : "#475569", fontWeight: filterEpic === key ? 700 : 400 }}>{e.label}</button>
        ))}
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(5, minmax(220px, 1fr))", gap: 12, overflowX: "auto" }}>
        {COLS.map(col => {
          const colTasks = allVisible.filter(t => t.col === col.id);
          const colTop   = colTasks.filter(t => !t.sub);
          const colH     = colTop.filter(t => t.h > 0).reduce((s, t) => s + (t.h || 0), 0);
          const cs = COL_STYLE[col.id];
          return (
            <div key={col.id}>
              <div style={{ background: cs.bg, border: `1px solid ${cs.border}`, borderRadius: "8px 8px 0 0", padding: "8px 12px", fontWeight: 700, fontSize: 13, color: "#1e293b", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <span>{col.label}</span>
                <span style={{ display: "flex", gap: 5 }}>
                  <span style={{ background: cs.border, color: "#fff", borderRadius: 10, fontSize: 11, padding: "1px 8px" }}>{colTop.filter(t => t.h > 0).length}</span>
                  <span style={{ background: "#fff", color: cs.border, border: `1px solid ${cs.border}`, borderRadius: 10, fontSize: 11, padding: "1px 7px", fontWeight: 600 }}>{colH}h</span>
                </span>
              </div>
              <div style={{ background: "#fafafa", border: `1px solid ${cs.border}`, borderTop: "none", borderRadius: "0 0 8px 8px", padding: 8, minHeight: 60 }}>
                {colTop.length === 0
                  ? <p style={{ fontSize: 11, color: "#94a3b8", textAlign: "center", margin: "16px 0" }}>Sin tareas</p>
                  : <ColContent tasks={colTasks} state={state} onOpen={setActiveTask} />
                }
              </div>
            </div>
          );
        })}
      </div>

      <div style={{ textAlign: "center", marginTop: 14, fontSize: 11, color: "#94a3b8" }}>
        Toca ··· o cualquier tarea para ver opciones · Los cambios se pierden al cerrar — descarga y actualiza el archivo para persistirlos
      </div>
    </div>
  );
}
